import { CommonModule } from '@angular/common';
import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { Dashboard, Section, TriggerEventType } from '../../../models';
import { DiagramBuilderComponent } from './diagram-builder.component';

@Component({
    selector: 'iq-builder-iq-builder-audit-tool-dashboard-events',
    standalone: true,
    imports: [CommonModule, DiagramBuilderComponent],
    templateUrl: './iq-builder-audit-tool-dashboard-events.component.html',
    styleUrl: './iq-builder-audit-tool-dashboard-events.component.scss',
})
export class IqBuilderAuditToolDashboardEventsComponent {
    dashboardInfo?: InputSignal<Dashboard> = input();

    eventInfo: Signal<
        { id: string; trackId: string; events: TriggerEventType }[]
    > = computed(() => {
        const dashboard: Dashboard = this.dashboardInfo();
        const sectionEvents =
            dashboard?.sections?.map((section) => ({
                id: section.id,
                trackId: Math.random().toString(),
                events: section,
            })) ?? [];

        const components =
            dashboard?.sections
                ?.reduce((acc, section: Section) => {
                    return [...acc, ...(section.components ?? [])];
                }, [])
                .map((component) => ({
                    id: component.id,
                    trackId: Math.random().toString(),
                    events: component,
                })) ?? [];

        return [
            {
                id: dashboard.id,
                trackId: Math.random.toString(),
                events: dashboard,
            },
            ...sectionEvents,
            ...components,
        ];
    });
}
